<template>
  <div class="au-brand" :class="variant === 'hero' ? 'au-brand--hero' : 'au-brand--compact'">
    <h1 class="au-wordmark">{{ STRINGS.branding.title }}</h1>

    <template v-if="variant === 'hero'">
      <p class="au-tagline">{{ STRINGS.branding.tagline }}</p>
      <div class="au-vs" aria-hidden="true">
        <span class="au-vs-rule au-vs-rule--l"></span>
        <span class="au-vs-txt">VS</span>
        <span class="au-vs-rule au-vs-rule--r"></span>
      </div>
    </template>

    <template v-else>
      <span class="au-hairline" aria-hidden="true"></span>
      <h2 v-if="title" class="au-title">{{ title }}</h2>
    </template>
  </div>
</template>

<script setup lang="ts">
import STRINGS from '@/constants/strings';

defineProps<{
  variant: 'hero' | 'compact';
  title?: string;
}>();
</script>
